export * from "./layout/actions"

// Authentication module
export * from "./auth/login/actions"

//dashboard
export * from "./dashboard/actions"
import { API_ERROR } from "./actionTypes"
export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}
